import React from "react";

import { format } from "date-fns";
import { DATE_FNS_SHORT_DATE_FORMAT } from "../../../../shared/constants";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive } from "@fortawesome/free-solid-svg-icons";

import classnames from "classnames";
import "./picklist.scss";

//To bind each list row
const AttributesList = ({ attribute, archiveAttribute, isArchiveList, disabled }) => {
    const createdOrUpdatedOnText = attribute.updatedOn !== null ? "Last edited" : "Created on";
    const createdOrUpdatedOnDate = attribute.updatedOn !== null ? attribute.updatedOn : attribute.createdOn;
    const createdOrUpdatedByText = attribute.updatedOn !== null ? "last edited by" : "added by";
    const createdOrUpdatedByName = attribute.updatedOn !== null ? attribute.updatedBy : attribute.createdBy;

    return (
        <div className={classnames("picklist-attributes", { "-inactive": isArchiveList })}>
            <div>
                <b>{attribute.text}</b>
                <br />
                <small>
                    {" "}
                    {createdOrUpdatedByText} {createdOrUpdatedByName}
                </small>
            </div>
            <div>
                {format(new Date(createdOrUpdatedOnDate), DATE_FNS_SHORT_DATE_FORMAT)}
                <br />
                <small>{createdOrUpdatedOnText}</small>
            </div>
            {!isArchiveList && (
                <button
                    className="button -text"
                    disabled={disabled}
                    onClick={() => {
                        archiveAttribute(attribute);
                    }}
                >
                    <FontAwesomeIcon icon={faArchive} />
                </button>
            )}
        </div>
    );
};

//To bind Active and Archive list
const DisplayAttributesList = ({ attributes, archiveAttribute, isArchiveList, viewOnlyUpdate }) => {
    const attributesHtml = attributes.map((attribute) => {
        return (
            <AttributesList
                key={attribute.text}
                attribute={attribute}
                archiveAttribute={archiveAttribute}
                isArchiveList={isArchiveList}
                disabled={viewOnlyUpdate}
            />
        );
    });

    return <div className={classnames("picklist-list-attributes", "picklist-contentWidth")}>{attributesHtml}</div>;
};

export default DisplayAttributesList;
